<script setup lang="ts">
const { cart } = useCart();
</script>

<template>
  <UiSidebarCard v-if="cart.lillopoints.max_points > 0" title="Lillopoints">
    <template #picto>
      <SvgPictoLillopoints />
    </template>
    <CartApplyLillopointsForm />
  </UiSidebarCard>
</template>
